import * as React from "react";
import {cs} from "../../../../../../react/chain-services";
import {Static2} from "../../../../../../react/static-2";
import "./data-table-m.scss";
import {css, cx} from "emotion";
import {chain} from "../../../../../../utils/fs";
import {PageList} from "../../pagination-ui/page-list/page-list";
import {UseState} from "../../../../../../react/use-state";
import {ellipsisMiddle} from "./ellipsis-middle";
import {keyed} from "../../../../../../react/keyed";
import {ScrollShadow} from "../../../../../scroll-shadow/scroll-shadow";
import {DomSizeObserver} from "../../../../../dom-size-observer";

export const DataTableM = (
    {
        rows, className=undefined, darkRows="odd", columns, controls, emptyAction,
        pagination, extraTopHeight=0,
    }
) => cs(
    ({}, next) => (
        <div className={cx("data-table-m-1eu", css`--extraTopHeight: ${extraTopHeight}px;`)}>
            {!rows?.length ? (
                <div className={cx("content no-data", {disabled: !emptyAction.onClick})}>
                    {emptyAction.onClick ? (
                        <a onClick={emptyAction.onClick}>{emptyAction.label}</a>
                    ) : (
                        emptyAction.label
                    )}
                </div>
            ) : (
                next()
            )}

            <div className="controls">


                {pagination.active && (
                    <div className="page-list">
                        {PageList(pagination)}
                    </div>
                )}

                <div className="buttons">
                    {controls.map((control, i) => (
                        <button {...{
                            onClick: control.onClick,
                            key: i,
                            "xd-qa-type": "button",
                            "xd-qa-name": control.label,
                        }}>
                            {control.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    ),

    ["scrollShadow", (_, next) => ScrollShadow({direction: "horizontal", next})],

    ["thWidth", (_, next) => DomSizeObserver({
        translate: ({width}) => width,
        defaultValue: 200,
        next,
    })],
    ["scrollbarHeight", (_, next) => UseState({next})],
    ["scrollbarHeightSet", (_, next) => Static2({next})],
    ({scrollShadow, scrollbarHeight, thWidth, scrollbarHeightSet}) => (
        <div className="content table">
            <table
                className={cx("", className)} cellSpacing={0} cellPadding={0}
                ref={(dom) => {
                    if (!dom) {
                        return;
                    }
                    scrollShadow.domRef(dom);
                    if (!scrollbarHeightSet.get() && dom.offsetHeight - dom.clientHeight) {
                        scrollbarHeightSet.set(true);
                        scrollbarHeight.onChange(dom.offsetHeight - dom.clientHeight);
                    }
                }}
            >
                <colgroup>
                    <col width={0}/>
                    {rows.map((_, ri) => (
                        <col width="1%" key={ri}/>
                    ))}
                </colgroup>
                <tbody>
                {columns.map((col, colIndex) => (
                    <tr key={colIndex}>
                        <th
                            className={col.className}
                            ref={thWidth.ref}
                            {...col.domAttrs}
                        >
                            {col.render ? (
                                col.render()
                            ) : (
                                col.label
                            )}
                        </th>

                        {rows?.map((row, ri) => chain(
                            row.columns[colIndex],
                            (rowCol) => (
                                <td
                                    className={cx(col.className, {
                                        darkBackground: colIndex % 2 === (darkRows === "odd" ? 0 : 1),
                                    })}
                                    key={row.key ?? ri}
                                    {...rowCol.domAttrs}
                                >
                                    {rowCol.text ? (
                                        ellipsisMiddle(rowCol.text)
                                    ) : rowCol.actions ? (
                                        rowCol.actions.map((action, i) => cs(
                                            keyed(i),
                                            () => action.type === "edit" ? (
                                                <i
                                                    className={cx("fa fa-pencil edit")}
                                                    onClick={action.onClick}
                                                    xd-qa-type="icon"
                                                    xd-qa-name={action.xdQaName+" Edit"}
                                                />
                                            ) : (
                                                <a
                                                    className={"delete"}
                                                    onClick={action.onClick}
                                                    xd-qa-type="icon"
                                                    xd-qa-name={action.xdQaName+" Delete"}
                                                >&times;</a>
                                            ),
                                        ))
                                    ) : (
                                        rowCol.render?.()
                                    )}
                                </td>
                            )
                        ))}
                    </tr>
                ))}

                </tbody>

            </table>

            {scrollShadow.render({
                paddingLeft: thWidth.value,
                paddingBottom: scrollbarHeight.value,
            })}
        </div>
    ),
);
